import { OrderTypeSchema, type OrderType as GeneratedOrderType } from '~/services/api/generated'

// Mirrors backend App\Enums\Order\OrderType

export type OrderType = GeneratedOrderType

export const OrderType = {
  DELIVERY: OrderTypeSchema.enum.delivery,
  PICKUP: OrderTypeSchema.enum.pickup,
  DINE_IN: OrderTypeSchema.enum.dine_in
} satisfies Record<string, GeneratedOrderType>

export const OrderTypeValues = Object.freeze(OrderTypeSchema.options)
